import { render, staticRenderFns } from "./zjList.vue?vue&type=template&id=45c45242&scoped=true&"
import script from "./zjList.vue?vue&type=script&lang=js&"
export * from "./zjList.vue?vue&type=script&lang=js&"
import style0 from "./zjList.vue?vue&type=style&index=0&id=45c45242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c45242",
  null
  
)

component.options.__file = "zjList.vue"
export default component.exports